import { IQuestionnaireComment } from '../Model/Questionnaire'
import * as _ from 'lodash'

export default class CommentHelper {
    public static getLastComment(comments: Array<IQuestionnaireComment>) {
        let lastComment: string = ''

        if (comments && comments.length) {
            lastComment = _.orderBy(comments, x => x.createDate, 'desc')[0].content
        } else {
            lastComment = ''
        }

        return lastComment.replace(/\r/g, '').replace(/\n/g, '')
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/CommentHelper.ts